import React from "react";
import { Popover } from 'antd';
import { createElement } from 'react';
import './css.less';
export default class BigText extends React.Component {
    static defaultProps = {
        copyable: false,
        type: 'ignore',
    };
    className = '';
    copy = () => {
        const { children, copyable } = this.props;
        if (typeof children === 'string') {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', children);
            document.body.appendChild(input);
            input.select();
            input.setSelectionRange(0, children.length);
            if (document.execCommand('copy'))
                document.execCommand('copy');
            document.body.removeChild(input);
            if (typeof copyable === 'object' && copyable.onCopy && typeof copyable.onCopy === 'function') {
                copyable.onCopy();
            }
        }
    };
    renderContent() {
        const { props } = this;
        const showCopy = props.copyable && (this.className || props.copyable.alwaysShow);
        return (createElement("div", { className: `big-text ${this.className} ${props.className || ''}`, style: props.style || {} },
            createElement("span", { title: props.type === 'ignore' && props.children ? '详情查看' : '', className: `text big-text-${props.type || ''}` }, this.props.children),
            createElement("span", { className: "btn-arr" },
                showCopy && (createElement("span", { className: "c-btn copy-btn", onClick: this.copy }, "\u590D\u5236")),
                props.type === 'ignore' ? ('') : (createElement("span", { className: "c-btn more-btn", onClick: () => {
                        console.log('className', this.className);
                        const show = this.props.showMore ? this.props.showMore() : true;
                        show && (this.className = this.className ? '' : 'show-more');
                        this.setState({});
                    } }, this.className ? '收起' : '显示更多')))));
    }
    render() {
        const { props } = this;
        const content = this.renderContent();
        if (props.type === 'ignore') {
            if (props.tooltip?.noshow ?? false) {
                return content;
            }
            return (createElement(Popover, { trigger: "click", content: props.children, ...(props.tooltip || {}) }, content));
        }
        return content;
    }
}
